import { render, staticRenderFns } from "./DoctorNICUPrices.vue?vue&type=template&id=4dcc4856&scoped=true"
import script from "./DoctorNICUPrices.vue?vue&type=script&lang=js"
export * from "./DoctorNICUPrices.vue?vue&type=script&lang=js"
import style0 from "./DoctorNICUPrices.vue?vue&type=style&index=0&id=4dcc4856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc4856",
  null
  
)

export default component.exports